import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { MessageService } from 'primeng/api';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
interface RoleList {
  name: string;
}
@Component({
  selector: 'app-add-vendor-user',
  templateUrl: './add-vendor-user.component.html',
  styleUrl: './add-vendor-user.component.scss'
})
export class AddVendorUserComponent implements OnInit {
  userDetailsForm!: FormGroup;

  roleList!: RoleList[] | undefined;
  plantList: any[] = [];
  gateList: any[] = [];
  isApprover: any[] = [];
  approver_level_list: any[] = [];

  showPlant: boolean = false
  isGateKeeper: boolean = false
  showApprover: boolean = false;
  select_approver_level: boolean = false;
  isLoading: boolean = false;

  approve_level!: string;

  constructor(private fb: FormBuilder, private vendorService: VendorTsService, private messageService: MessageService, private shipment_asn: ShipmentASN) { }

  ngOnInit(): void {

    this.roleList = [
      { name: 'Vendor' },
      { name: 'Gate Keeper' },
      { name: 'Vendor Auditor' },
      { name: 'Vendor Admin' },
      { name: 'Vendor Super Admin' },
    ];
    this.isApprover = [
      { name: 'Yes' },
      { name: 'No' },
    ];
    this.approver_level_list = [
      { name: 'Approver 1', value: 'approver_1' },
      { name: 'Approver 2', value: 'approver_2' },
    ]

    this.userDetailsForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      role: ['Vendor', Validators.required],
      plant: [''],
      gate: [''],
      is_approver: [''],
      approval_level: ['']
    });
    this.getPlantList();
    this.getGateList();

    this.userDetailsForm.get('role')?.valueChanges.subscribe(role => {
      this.onSelectRole(role);
    });

    this.userDetailsForm.get('is_approver')?.valueChanges.subscribe(value => {
      this.onSelectApprover(value);
    });
  }

  get form() {
    return this.userDetailsForm.controls;
  }

  onSubmit() {
    if (this.userDetailsForm.invalid) {
      return;
    }
    const data = {
      data: this.userDetailsForm.value
    };
    this.isLoading = true
    this.vendorService.createUser(data)
      .then(response => {
        const successMessage = response.message.message;
        if (response.message.status === "Success") {
          this.userDetailsForm.reset()
          this.userDetailsForm.get('role')?.setValue('Vendor')
          this.messageService.add({ severity: 'success', summary: 'Success', detail: successMessage });
          this.isLoading = false
        }
      })
      .catch(error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.message });
        this.isLoading = false
      });
  }



  onSelectRole(role: any): void {
    this.userDetailsForm.get('plant')?.reset();
    this.userDetailsForm.get('gate')?.reset();
    this.userDetailsForm.get('is_approver')?.reset();
    this.userDetailsForm.get('approval_level')?.reset();

    const plantControl = this.userDetailsForm.get('plant');
    const gateControl = this.userDetailsForm.get('gate');

    if (role === 'Vendor Admin' || role === 'Vendor Super Admin') {
      this.showApprover = true;
    } else {
      this.showApprover = false;
      this.onSelectApprover({ name: 'No' });
    }

    if (role == "Vendor Admin" || role == "Vendor Super Admin" || role == "Gate Keeper") {
      this.showPlant = true;
      if (role == "Gate Keeper") {
        this.isGateKeeper = true;
        gateControl?.setValidators(Validators.required);
      } else {
        this.isGateKeeper = false;
        gateControl?.clearValidators();
      }
      plantControl?.setValidators(Validators.required);
    } else {
      this.showPlant = false;
      this.isGateKeeper = false;
      plantControl?.clearValidators();
      gateControl?.clearValidators();
    }

    plantControl?.updateValueAndValidity();
    gateControl?.updateValueAndValidity();
  }

  onSelectApprover(event: any) {
    const approvalLevelControl = this.userDetailsForm.get('approval_level');
    if (event.name == 'Yes') {
      this.select_approver_level = true;
      approvalLevelControl?.setValidators(Validators.required);
    } else {
      this.select_approver_level = false;
      approvalLevelControl?.clearValidators();
    }
    approvalLevelControl?.updateValueAndValidity();
  }

  getPlantList() {
    this.shipment_asn.getPlantList().then((res: any[]) => {
      this.plantList = res;
    })
      .catch((error: any) => {
        console.log(error);
      });
  }

  getGateList() {
    this.shipment_asn.getGateList().then((res: any[]) => {
      this.gateList = res;
    })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
